import { styled } from '@mui/material/styles';
import { Rating, Box } from '@mui/material';

interface StyledRatingProps {
  color?: 'primary' | 'secondary' | 'error' | 'warning' | 'success';
}

export const RatingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const StyledRating = styled(Rating, {
  shouldForwardProp: (prop) => prop !== 'color',
})<StyledRatingProps>(({ theme, color }) => {
  const getColor = () => {
    switch (color) {
      case 'primary':
        return theme.palette.primary.main;
      case 'secondary':
        return theme.palette.secondary.main;
      case 'error':
        return theme.palette.error.main;
      case 'success':
        return theme.palette.success.main;
      case 'warning':
        return theme.palette.warning.main;
      default:
        return theme.palette.warning.main;
    }
  };

  return {
    '& .MuiRating-iconFilled': {
      color: getColor(),
    },
    
    '& .MuiRating-iconHover': {
      color: getColor(),
    },
    
    '& .MuiRating-iconEmpty': {
      color: theme.palette.action.disabled,
    },
    
    '& .MuiRating-icon': {
      transition: theme.transitions.create('color', {
        duration: theme.transitions.duration.short,
      }),
    },
    
    '&.Mui-disabled': {
      '& .MuiRating-iconFilled': {
        color: theme.palette.action.disabled,
      },
    },
  };
}); 